import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ApisDefinitionItem, UpsertApisDefinitionRequest, Country, Port } from '../interfaces/apis-definitions.interface';

@Injectable({
    providedIn: 'root'
})
export class ApisDefinitionsService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl + '/apis/definitions';

    getApisDefinitions(): Observable<ApisDefinitionItem[]> {
        return this.http.get<ApisDefinitionItem[]>(this.baseUrl);
    }

    createApisDefinition(request: UpsertApisDefinitionRequest): Observable<ApisDefinitionItem> {
        return this.http.post<ApisDefinitionItem>(this.baseUrl, request);
    }

    updateApisDefinition(id: number, request: UpsertApisDefinitionRequest): Observable<ApisDefinitionItem> {
        const apiUrl = `${this.baseUrl}/${id}`;
        return this.http.put<ApisDefinitionItem>(apiUrl, request);
    }

    updateApisDefinitionStatus(id: number, active: boolean): Observable<ApisDefinitionItem> {
        const apiUrl = `${this.baseUrl}/${id}/status?active=${active}`;
        return this.http.patch<ApisDefinitionItem>(apiUrl, null);
    }

    getCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(`${environment.apiUrl}/countries`);
    }

    getPortsByCountry(countryCode: string): Observable<Port[]> {
        return this.http.get<Port[]>(`${environment.apiUrl}/ports?countryCode=${countryCode}`);
    }

    getAllPorts(): Observable<Port[]> {
        return this.http.get<Port[]>(`${environment.apiUrl}/ports`);
    }
}
